var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.21967 3.96967C6.51256 3.67678 6.98744 3.67678 7.28033 3.96967L11.7803 8.46967C12.0732 8.76256 12.0732 9.23744 11.7803 9.53033L7.28033 14.0303C6.98744 14.3232 6.51256 14.3232 6.21967 14.0303C5.92677 13.7374 5.92678 13.2626 6.21967 12.9697L10.1893 9L6.21967 5.03033C5.92678 4.73744 5.92678 4.26256 6.21967 3.96967Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMjE5NjcgMy45Njk2N0M2LjUxMjU2IDMuNjc2NzggNi45ODc0NCAzLjY3Njc4IDcuMjgwMzMgMy45Njk2N0wxMS43ODAzIDguNDY5NjdDMTIuMDczMiA4Ljc2MjU2IDEyLjA3MzIgOS4yMzc0NCAxMS43ODAzIDkuNTMwMzNMNy4yODAzMyAxNC4wMzAzQzYuOTg3NDQgMTQuMzIzMiA2LjUxMjU2IDE0LjMyMzIgNi4yMTk2NyAxNC4wMzAzQzUuOTI2NzcgMTMuNzM3NCA1LjkyNjc4IDEzLjI2MjYgNi4yMTk2NyAxMi45Njk3TDEwLjE4OTMgOUw2LjIxOTY3IDUuMDMwMzNDNS45MjY3OCA0LjczNzQ0IDUuOTI2NzggNC4yNjI1NiA2LjIxOTY3IDMuOTY5NjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";